const AccessLevel = {
  ADMIN: "ADMIN",
  RECRUITER: "RECRUITER",
  VIEWER: "VIEWER",
  ITP: "ITP",
  ANY: "ANY",
};

// // anyone can access
// const AccessLevelAny = {
//   accessLevel: [AccessLevel.ANY],
//   loginStatus: false,
// };

// // can be accessed by any recruiter who is logged in
// const AccessLevelAllRecruiters = {
//   accessLevel: [AccessLevel.ADMIN, AccessLevel.RECRUITER, AccessLevel.VIEWER],
//   loginStatus: true,
// };

export default AccessLevel;
